import './set_refuse_reason.css'
import React, { useState } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import CancelIcon from '@mui/icons-material/Cancel';
import SendIcon from '@mui/icons-material/Send';
import Backdrop from '@mui/material/Backdrop';
import swal from 'sweetalert';
import CircularProgress from '@mui/material/CircularProgress';
import { supplier_accord_order, supplier_change_order_state } from '../../../../../../services/supplier_service';


function Set_refuse_reason({open_reason_modal,setOpen_reason_modal,setOrder_state,products_bysupplier,setProducts_bysupplier,order_key}){


  const [errorText,setErrorText] = useState("");
  const [waiting, setWaiting] = useState(false);

  const [reason,setReason]=useState('');


  function submit_refuse_reason() {
    setErrorText("");
    if(reason===''){
        setErrorText("Champ vide !");
      }else{
        swal({
            title: "Etes-vous sûr ?",
            text: "Une fois que vous avez soumis votre réponse, vous ne pourrez plus la modifier !",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
        .then((willDelete) => {
          if (willDelete) {
          setWaiting(true);
          open_reason_modal.append('refuse_reason',reason);
          if(open_reason_modal.get('state')){
            supplier_change_order_state(open_reason_modal).then((response)=>{
              setOpen_reason_modal(null);
              setWaiting(false);
              setOrder_state("sous réserve de validation");
              let tmp_products = { ...products_bysupplier };
              tmp_products[order_key].service_accord = true;
              tmp_products[order_key].order_state = "sous réserve de validation";
              tmp_products[order_key].refuse_reason = reason;
              setProducts_bysupplier(tmp_products);
              swal("votre réponse a été enregistrée avec succès et le service sera bientôt notifié !", {
                icon: "success",
                });
            }).catch((error)=>{
              //console.log(error.response);
              setWaiting(false);
            })
          }else{
            supplier_accord_order(open_reason_modal).then((response)=>{
              setOpen_reason_modal(null);
              setWaiting(false);
              setOrder_state("refusée");
              let tmp_products = { ...products_bysupplier };
              tmp_products[order_key].service_accord = true;
              tmp_products[order_key].order_state = "refusée";
              tmp_products[order_key].refuse_reason = reason;
              setProducts_bysupplier(tmp_products);
              swal("votre réponse a été enregistrée avec succès et le service sera bientôt notifié !", {
                icon: "success",
                });
            }).catch((error)=>{
              //console.log(error.response);
              setWaiting(false);
            })
          }
          
        }
      });
      }      
   }

     

    return (
      <Dialog className="set_refuse_raison_container" fullWidth={true} maxWidth={'md'} open={open_reason_modal!=null?true:false} onClose={()=>setOpen_reason_modal(null)} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-title">Motif</DialogTitle>
        <DialogContent>
          <div>
              <div style={{width:"100%",marginTop:"5px"}} >
              <TextField
                  id="outlined-multiline-flexible"
                  label="Motif"
                  variant='outlined'
                  multiline
                  minRows={4}
                  value={reason}
                  onChange={(e)=>setReason(e.target.value)} 
                  style={{width:"100%"}}
                />
              </div>
          </div>
          
     </DialogContent>
        <DialogActions>
          <div className='dialogBottom'>
            <div>
                {
                    errorText === ""
                    ?<></>
                    :<p className={errorText ? "col-md-10 error" : "col-md-10 valid-champ"}>
                            {errorText}
                        </p>
                }
            </div>
            <div>
              <Button variant="contained" className="submit_but cancel_but" startIcon={<CancelIcon className="my_icon"  />} onClick={()=>setOpen_reason_modal(null)} >
                  Annuler
              </Button>
              <Button variant="contained" className="submit_but valide_but" startIcon={<SendIcon className="my_icon"  />} onClick={submit_refuse_reason} >
                  Envoyer
              </Button> 
            </div>
          </div>
        </DialogActions>

        <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

      </Dialog>
    )
}

export default Set_refuse_reason
